import React from 'react';
import { useLocation } from 'react-router-dom';

import NotFound from './NotFound';
import ErrorView from './ErrorView';
import { logError } from 'utils';

class ErrorObserver extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: this.props.hasError };
  }

  componentDidUpdate(prevProps) {
    if (this.state.hasError && prevProps.pathname !== this.props.pathname) {
      return this.setState({ hasError: false });
    }
    if (this.props.hasError && !this.state.hasError) {
      this.setState({ hasError: true });
    }
  }

  componentDidCatch(error, info) {
    this.handleError(error, info);
  }

  handleError(error, info) {
    if (this.state.hasError) return;

    this.setState({ hasError: true });
    logError(error, info);
  }

  render() {
    const {
      errorObject,
      children = null,
      homeButton = false,
      allowRefresh = false
    } = this.props;

    if (!this.state.hasError) return children;

    let message = undefined;
    if (typeof errorObject === 'string') {
      message = errorObject;
    } else if (typeof errorObject === 'object' && errorObject !== null) {
      message =
        typeof errorObject.displayMessage === 'string'
          ? errorObject.displayMessage
          : 'Something went wrong. Please try again later.';
    }
    if (
      typeof errorObject === 'object' &&
      errorObject !== null &&
      errorObject.statusCode === 404 &&
      errorObject.method === 'get'
    ) {
      return <NotFound />;
    }
    return (
      <ErrorView
        message={message}
        homeButton={homeButton}
        allowRefresh={allowRefresh}
      />
    );
  }
}

export default function Observer({
  hasError = false,
  errorObject = null,
  homeButton = false,
  allowRefresh = true,
  children = null
}) {
  const { pathname } = useLocation();

  return (
    <ErrorObserver
      pathname={pathname}
      hasError={hasError}
      errorObject={errorObject}
      homeButton={homeButton}
      allowRefresh={allowRefresh}
    >
      {children}
    </ErrorObserver>
  );
}
